// Importando as bibliotecas necessárias
import React, {useState, useEffect } from "react";
import axios from "axios";
import { useAuthUser, useAuthHeader} from 'react-auth-kit'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserGroup, faUserPlus, faShieldHalved, faTrashCan, faCircleCheck, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import './admin.css';

// Definindo a URL do backend a partir das variáveis de ambiente
const backend = process.env.REACT_APP_BACKEND_API;

// Componente principal do painel de administração
export default function Admin() {
    // Obtendo informações do usuário autenticado
    const auth = useAuthUser()
    const authHeader = useAuthHeader();
    const token = authHeader();
    
    // Estado para armazenar a lista de usuários
    const [userList, setUserList] = useState([]);

    // Efeito colateral para buscar dados ao montar o componente
    useEffect(() => {
      fetchData();
    }, []);

    // Função para buscar a lista de usuários do backend
    const fetchData = async () => {
        try {
            const config = {
              headers: {
                Authorization: `${token}`, // Adicionando o token de autenticação no cabeçalho
              },
            };
            // Fazendo a requisição GET para obter a lista de usuários
            const response = await axios.get(backend + "/users", config);
            setUserList(response.data); // Atualizando o estado com a lista de usuário
        } catch (error) {
            console.log(error); // Logando erros no console
        }
    };
    const [newUserName, setNewUserName] = useState("");
    const [newUserEmail, setNewUserEmail] = useState("");
    const [newUserRole, setNewUserRole] = useState("user");

    const user_create = async () => {
        const newUser = {
            name: newUserName,
            email: newUserEmail,
            role: newUserRole
        };

        try {
            const config = {
                headers: {
                    Authorization: `${token}`,
                },
            };
            const response = await axios.post(backend + "/users", {
                name: newUser.name,
                email: newUser.email,
                password: "123456", // Defina uma senha padrão ou gere uma
                role: newUser.role,
                active: "false" 
            }, config);
            fetchData(); // Atualiza a lista de usuários após a criação
            // Limpa os campos após a criação
            setNewUserName("");
            setNewUserEmail("");
            setNewUserRole("user");
        } catch (error) {
            console.log(error);
            alert("Ocorreu um erro ao criar o usuário. Tente novamente."); // Mensagem de erro na tela
        }
    };

    const toggleUserActive = async (userId) => {
      
        try {
            const config = {
                headers: {
                    Authorization: `${token}`,
                },
            };
            const user = userList.find(u => u._id === userId);
            const updatedUser = {
                ...user,
                active: !user.active // Alterna o estado ativo do usuário
            };
            console.log(updatedUser);

            await axios.put(backend + `/users/${userId}`, updatedUser, config);
            fetchData(); // Atualiza a lista de usuários após a alteração
        } catch (error) {
            console.log(error);
        }
    };
    const deleteUser = async (userId) => {
        try {
            const config = {
                headers: {
                    Authorization: `${token}`,
                },
            };
            await axios.delete(backend + `/users/${userId}`, config);
            fetchData(); // Atualiza a lista de usuários após a exclusão
        } catch (error) {
            console.log(error);
        }
    };
    // Verificando se o usuário tem a função de admin
    if (auth().role === "admin"){
        return (
            <main className="admin-page">
              <div className="admin-shell">
                <header className="admin-heading">
                  <div>
                    <span className="admin-eyebrow">Administração</span>
                    <h1>Usuários</h1>
                    <p>Gerencie acessos, perfis e permissões do HealthPad.</p>
                  </div>
                  <div className="admin-count"><FontAwesomeIcon icon={faUserGroup} /> {userList.length} contas</div>
                </header>

                <section className="admin-card user-table-card">
                  <div className="admin-card-heading">
                    <div><h2>Contas cadastradas</h2><p>Ative ou remova usuários com acesso à plataforma.</p></div>
                    <span className="admin-card-icon"><FontAwesomeIcon icon={faShieldHalved} /></span>
                  </div>
                  <div className="admin-table-wrap">
                  <table className="table admin-table">
                    <thead>
                      <tr>
                        <th>Nome</th>
                        <th>ID</th>
                        <th>Email</th>
                        <th>Função</th>
                        <th>Estado</th>
                        <th>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {userList.map((user) => (
                        <tr key={user._id}>
                          <td className="user-name-cell"><strong>{user.name}</strong></td>
                          <td><span className="user-id">{user._id}</span></td>
                          <td>{user.email}</td>
                          <td><span className={`role-badge role-${user.role}`}>{user.role}</span></td>
                          <td>
                            <button type="button" className={`status-button ${user.active ? 'is-active' : 'is-inactive'}`} onClick={() => toggleUserActive(user._id)}>
                              <FontAwesomeIcon icon={user.active ? faCircleCheck : faCircleXmark} /> {user.active ? 'Ativo' : 'Inativo'}
                            </button>
                          </td>
                          <td>
                            {user._id !== auth().id && (
                              <button type="button" className="delete-button" onClick={() => deleteUser(user._id)}><FontAwesomeIcon icon={faTrashCan} /> Excluir</button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  </div>
                </section>

                <section className="admin-card create-user-card">
                  <div className="admin-card-heading">
                    <div><h2><FontAwesomeIcon icon={faUserPlus} /> Criar usuário</h2><p>O usuário receberá uma senha provisória para o primeiro acesso.</p></div>
                  </div>
                  <form onSubmit={(e) => { e.preventDefault(); user_create(); }} className="create-user-form">
                    <label htmlFor="name">Nome<input type="text" className="form-control" id="name" placeholder="Nome completo" value={newUserName} onChange={(e) => setNewUserName(e.target.value)} required /></label>
                    <label htmlFor="email">Email<input type="email" className="form-control" id="email" placeholder="email@exemplo.com" value={newUserEmail} onChange={(e) => setNewUserEmail(e.target.value)} required /></label>
                    <label htmlFor="role">Função<select className="form-select" id="role" value={newUserRole} onChange={(e) => setNewUserRole(e.target.value)} required>
                      <option value="user">User</option>
                      <option value="admin">Admin</option>
                    </select></label>
                    <button type="submit" className="btn admin-primary-button"><FontAwesomeIcon icon={faUserPlus} /> Criar usuário</button>
                  </form>
                </section>
              </div>
            </main>
          );
    } else {
        // Mensagem de acesso negado para usuários não administradores
        return (
        <main className="admin-page"><div className="admin-denied">Acesso restrito a administradores.</div></main>
        );
    }
}


//<li className="list-group-item" key={user._id}>
//<strong>{user.name}</strong> - {user._id} - {user.email} - {user.role} - <a href="#" onClick={() => toggleUserActive(user._id)}>{user.active ? 'Ativo' : 'Inativo'}</a> - {user._id !== auth().id && <a href="#" onClick={() => deleteUser(user._id)}>Deletar</a>}
//</li>